import { render, staticRenderFns } from "./ReservationIndex.vue?vue&type=template&id=96c495c8&scoped=true&"
import script from "./ReservationIndex.vue?vue&type=script&lang=js&"
export * from "./ReservationIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReservationIndex.vue?vue&type=style&index=0&id=96c495c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c495c8",
  null
  
)

export default component.exports